<template>
  <div
    :class="{ 'reverse-row': isFromUser }"
    class="app-chat-message-container d-flex column-gap-2"
    data-locator="app-chat-message"
  >
    <div v-if="$slots['message-author']" class="message-author">
      <slot name="message-author" />
    </div>

    <div class="d-flex flex-column flex-grow-1 row-gap-2">
      <AppCard
        v-if="!isFromUser && isReady && !isError"
        class="app-chat-message d-flex column-gap-2 pa-4 flex-grow-1 message-from-ai"
        elevation="2"
      >
        <div class="d-flex column-gap-2">
          <app-material-icon name="check" class="text-success cursor-default" />
          <span class="font-weight-bold">{{ $t('common.ai-assistant.AIAssistantMessages.promptReady') }}</span>
        </div>
      </AppCard>

      <AppCard
        :class="{ 'flex-grow-1 message-from-ai': !isFromUser, 'message-from-user': isFromUser }"
        class="app-chat-message d-flex column-gap-2 pa-4"
        :elevation="isFromUser ? 0 : 2"
      >
        <template v-if="shouldDisplayErrorMessage">
          <app-material-icon name="info" color="#D10027" />
        </template>
        <div class="w-100">
          <p class="text--small text--regular mb-0 app-chat-message-content">
            <slot />
          </p>
          <slot name="message-footer"></slot>
        </div>
      </AppCard>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import AppCard from '@/common/AppCard.vue'
import { DARK_BLUE_DARKEST } from '@/common/utils/colors'

export default defineComponent({
  name: 'AppChatMessage',
  components: { AppCard },
  props: {
    isFromUser: {
      type: Boolean,
      default: false,
    },
    shouldDisplayErrorMessage: {
      type: Boolean,
      default: false,
    },
    isReady: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DARK_BLUE_DARKEST,
    }
  },
})
</script>

<style scoped>
.app-chat-message {
  &.message-from-ai {
    border-top-left-radius: 0;
    color: v-bind(DARK_BLUE_DARKEST);
  }

  :deep(&.message-from-user) {
    background-color: #7247C9;
    color: white;
    border-top-right-radius: 0;
    & p {
      margin: 0;
    }
  }
}

:deep(.app-chat-message-content) {
  /* Block content that could be output */
  blockquote, header, hr, ol, p, pre, section, table, ul  {
    margin-bottom: 16px;
  }

  h1 {
    font-size: 16px;
  }

  h2 {
    font-size: 14px;
  }

  h3 {
    font-size: 13px;
  }

  h1, h2 {
    font-weight: bold;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 12px;
  }

  ol, ul {
    margin-left: 20px;
  }
  pre {
    white-space: pre-wrap;
  }
  pre * {
    font-family: 'Lato', sans-serif;
  }
}

.reverse-row {
  flex-direction: row-reverse;
}

.message-author {
  width: 28px;
}
</style>
